import "components/CustomerModal/components/CustomerNotes/components/CustomerNoteRow/components/CustomerNoteUserInfo/CustomerNoteUserInfo.scss";
import { DATE_FORMATS_FNS } from "components/DatePicker";
import { formatDate } from "utils/dateHelperFunctions";

import type { TFunction } from "i18next";
import type { User } from "models";

type CustomerNoteUserInfoProps = {
  t: TFunction;
  userId: number;
  user?: User;
  updatedBy?: User;
  updatedOn?: string;
  createdOn?: string;
};

export const CustomerNoteUserInfo = ({ userId, createdOn, updatedBy, updatedOn, user, t }: CustomerNoteUserInfoProps) => {
  const getUserInfo = () => {
    if (updatedBy) {
      if (userId)
        return (
          <>
            <span className="user-name">{`${t("v8_updated_by", "Updated by")} ${updatedBy.first_name} ${updatedBy.last_name} ${t("v8_on", "on")}`}</span>
            {updatedOn && <span>{formatDate(updatedOn, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
          </>
        );

      return <>{updatedOn ? `${t("v8_updated_on", "Updated on")} ${formatDate(updatedOn, DATE_FORMATS_FNS.dateMonthYearTime)}` : ""}</>;
    }

    if (userId && user && createdOn)
      return (
        <>
          <span className="user-name">{`${t("v8_added_by", "Added by")} ${user.first_name} ${user.last_name} ${t("v8_on", "on")}`}</span>
          {createdOn && <span>{formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
        </>
      );

    return <>{createdOn ? `${t("v8_added_on", "Added on")} ${formatDate(createdOn, DATE_FORMATS_FNS.dateMonthYearTime)}` : ""}</>;
  };

  return <div className="CustomerNoteUserInfo">{getUserInfo()}</div>;
};
